export const flowchartStyles = theme => ({
  button: {
    margin: theme.spacing(),
  }
})